import Vue from "vue";

export default {
  feedbackAssignedToMe({ commit }) {
    return new Promise((resolve, reject) => {
      commit("tableLoading", true);

      Vue.$http
        .get(`/hrm/surveys/assigned-to-me`)
        .then(response => {
          commit("allFeedbackAssignedToMe", response.data);
          commit("tableLoading", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoading", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  getFeedbackSurveyById({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/hrm/surveys/${id}`)
        .then(response => {
          commit("setSelectedRow", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  submitSurveyAnswers({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit("tableLoading", true);

      Vue.$http
        .post(`/hrm/surveys/answer`, payload)
        .then(response => {
          commit("tableLoading", false);
          Vue.$notification.success("Survey answers submitted successfully", {
            offset: 120,
          });
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoading", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  feedbackAppliedToMe({ commit }) {
    return new Promise((resolve, reject) => {
      commit("tableLoading", true);

      Vue.$http
        .get(`/hrm/surveys/applied-to-me`)
        .then(response => {
          commit("allFeedbackAppliedToMe", response.data);
          commit("tableLoading", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoading", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
};
